module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_6-8fb5de0891b9b612b975ea14dc0622cf.svg";